import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.032 6.188c-.334.438-.53 1.077-.532 1.775V9.5h-2V7.96c.002-1.034.287-2.126.942-2.985C10.12 4.085 11.16 3.5 12.5 3.5c1.358 0 2.396.62 3.066 1.515.647.863.934 1.952.934 2.956V9.5h-2V7.97c0-.653-.192-1.299-.535-1.756-.32-.428-.782-.714-1.465-.714-.698 0-1.157.28-1.468.688Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 8.5h2v11h12v-11h2v13h-16v-13Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }